var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#3A8F78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3428 6.80524C12.3037 6.68274 12.2287 6.57485 12.1275 6.49565C12.0262 6.41644 11.9034 6.36959 11.7751 6.36121L9.45519 6.19885L8.59459 4.0318C8.54802 3.91199 8.46634 3.80905 8.36026 3.73646C8.25418 3.66387 8.12865 3.62502 8.00011 3.625H7.9995C7.87116 3.62523 7.74588 3.66418 7.64003 3.73676C7.53418 3.80934 7.4527 3.91217 7.40624 4.0318L6.53282 6.21136L4.22569 6.36121C4.09741 6.36959 3.97463 6.41644 3.87337 6.49565C3.77212 6.57485 3.69708 6.68274 3.65807 6.80524C3.61691 6.92947 3.61411 7.06322 3.65003 7.18906C3.68596 7.31491 3.75894 7.42702 3.85948 7.5108L5.63439 9.01105L5.10643 11.0878C5.07004 11.2277 5.07673 11.3753 5.12563 11.5113C5.17453 11.6473 5.26335 11.7654 5.38048 11.8501C5.49356 11.9324 5.62879 11.9787 5.76856 11.9831C5.90834 11.9874 6.04619 11.9496 6.16417 11.8745L7.99522 10.7145C7.99767 10.7127 8.00011 10.7115 8.0056 10.7145L9.97582 11.9627C10.0828 12.031 10.2079 12.0655 10.3347 12.0616C10.4616 12.0577 10.5843 12.0155 10.6869 11.9407C10.793 11.864 10.8735 11.757 10.9178 11.6338C10.9621 11.5106 10.9682 11.3769 10.9353 11.2501L10.3744 8.98145L12.1413 7.5108C12.2419 7.42702 12.3149 7.31491 12.3508 7.18906C12.3867 7.06322 12.3839 6.92947 12.3428 6.80524Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.ed6611873b845f61d5ce4b3adfd111f2.svg";
export { ForwardRef as ReactComponent };